<template>
  <section :color="color" class="scn scn--mobile" :class="color ? `scn--${color}` : undefined">
    <div class="title" :class="borderColor ? `border-${borderColor}` : undefined">
      <div class="title-border title-border--horizontal title-border--left"
           :class="`bg-${borderColor}`"
      />
      <div class="title-border title-border--vertical title-border--left"
           :class="`bg-${borderColor}`"
      />
      <slot name="title" />
      <div class="title-border title-border--horizontal title-border--right"
           :class="`bg-${borderColor}`"
      />
      <div class="title-border title-border--vertical title-border--right"
           :class="`bg-${borderColor}`"
      />
      <slot name="divider" />
    </div>
    <div class="content" :class="borderColor ? `border-${borderColor}` : undefined">
      <slot />
    </div>
    <div class="footer">
      <slot name="footer" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'MobileScn',
  props: {
    color: String,
    borderColor: {
      type: String,
      required: true
    }
  },
  comments: true
}
</script>

<style scoped lang="sass">
/* purgecss start ignore */
@tailwind utilities

.title
  @apply relative h-48

.title-border
  @apply absolute z-10
  &--vertical
    @apply pin-b w-px h-1/2
  &--horizontal
    @apply half-t -translate-y-50 w-8 h-px
  &--left
    left: 1rem
  &--right
    right: 1rem

.content
  @apply leading-normal font-thin text-white border-l border-r border-b p-2 mx-2
  letter-spacing: 1px

.footer
  @apply text-center text-white text-lg mt-3
/* purgecss end ignore */
</style>
